/* 
Author:Lamiaa Moustafa
Desc: All Divs containers styles js
*/

import styled from "styled-components";

//login btn div style
export const ButtonDiv = styled.div`
  height: 15vh;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: var(--fontFamily);
  @media (max-width: 768px) {
    width: 100%;
  }
  .linkStyle {
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: 400;
    color: var(--white);
    cursor: pointer;
    z-index: 99;
    &:hover {
      color: var(--orange);
      text-decoration: underline;
      font-style: italic;
    }
    @media (max-width: 768px) {
      margin-left: 15px;
    }
  }
`;

// transparency background div style
export const TransDiv = styled.div`
  width: 65%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 12%;
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 6%;
  }
  h2:first-child {
    margin-bottom: 0;
  }
  h2:nth-child(2) {
    margin-top: 0;
    margin-bottom: 20px;
  }
  &:after {
    content: "";
    background-color: var(--black);
    opacity: 0.4;
    width: 65%;
    height: 520px;
    position: absolute;
    padding: 2em;
    @media (max-width: 768px) {
      width: 100%;
      height: 60vh;
    }
  }
`;

//authentication main div style
export const AuthDiv = styled.div`
  height: 15vh;
  min-height: 170px;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  input {
    margin: 0 auto;
  }
  input::placeholder {
    text-align: center;
  }

  .linkStyle {
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: 400;
    color: var(--white);
    cursor: pointer;
    z-index: 99;
    @media (max-width: 768px) {
      text-align: center;
    }
    &:hover {
      color: var(--orange);
      text-decoration: underline;
      font-style: italic;
    }
  }
`;

// authentication btn div style
export const AuthBtnDiv = styled.div`
  height: 10vh;
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  .linkStyle {
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: 400;
    color: var(--white);
    cursor: pointer;
    z-index: 99;
    &:hover {
      color: var(--orange);
      text-decoration: underline;
      font-style: italic;
    }
    @media (max-width: 768px) {
      margin-left: 15px;
    }
  }
`;

//Error page main div style
export const ErrorDiv = styled.div`
  width: 100%;
  height: 97vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 60px;
  p {
    color: var(--darkGray);
    margin-top: 1em;
    font-family: var(--fontFamily);
  }
  .RobotSvg {
    max-width: 20%;
    min-width: 300px;
  }
  @media (max-width: 768px) {
    padding-top: 30px;
  }
`;

//contact Page Button div style
export const SubmitDiv = styled.div`
  width: 75%;
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

//react select div style in register page
export const SelectDiv = styled.div`
  width: 100%;
  height: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  label {
    align-self: flex-start;
    margin-left: 22%;
    padding-left: 0;
  }
  @media (max-width: 768px) {
    label {
      margin-left: 10%;
      padding-left: 0;
    }
  }
  @media (min-width: 1400px) {
    label {
      margin-left: 25%;
      padding-left: 0;
    }
  }
`;

//Account pop up div style
export const PopupDiv = styled.div`
  display: flex;
  padding: 10px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--lightGray);
`;

//Avatar image and info div style
export const AvatarDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

//Avatar image div style
export const AvatarPhotoDiv = styled.div`
  display: flex;
  padding: 10px 5px;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const FlexDiv = styled.div`
  width: 100%;
  display: flex;
  padding: 5px;
  justify-content: flex-start;
  align-items: flex-start;
`;
